let resumeData = {
    "imagebaseurl":"https://github.com/malshaheri",
    "name": "Mohammed Alshaheri",
    "role": "Frontend Developer",
    "linkedinId":"Your LinkedIn Id",
    "skypeid": "Your skypeid",
    "roleDescription": "I like dabbling in various parts of frontend development and like to learn about new technologies, write technical articles or simply play games in my free time.",
    "socialLinks":[
        {
          "name":"linkedinId",
          "url":"https://www.linkedin.com/in/mohamed-ahmed-alshaheri-88287a12/",
          "className":"fa fa-linkedin"
        },
        {
          "name":"github",
          "url":"https://github.com/malshaheri",
          "className":"fa fa-github"
        },
        {
          "name":"skype",
          "url":"https://twitter.com/m_alshaheri",
          "className":"fa fa-twitter"
        }
      ],
    "aboutme":"I’m a Front-End Developer located in Germany. Well-organized person, problem solver, independent employee with high attention to detail., outdoor activities, TV series and English literature. A family person and father of three kids.. I believe that to be successful in life, one needs to be obsessive with their dreams and keep working towards them.",
    "address":"Deutschland",
    "website":"https://github.com/malshaheri",
    "education":[
      {
        "UniversityName":"Digital Career Institute",
        "specialization":"Web developing",
        "MonthOfPassing":"Sep",
        "YearOfPassing":"2021",
      },
      {
        "UniversityName":"Sana'a University",
        "specialization":"Faculty Of Arts",
        "MonthOfPassing":"Jan",
        "YearOfPassing":"2000",
      }
    ],
    "work":[
      {
        "CompanyName":"AbuIssa Gorup- Doha",
        "specialization":"HR- coordinator",
        "MonthOfLeaving":"Oct",
        "YearOfLeaving":"2018",
        
      },
      {
        "CompanyName":"Alshaya Group",
        "specialization":"Operation Manager",
        "MonthOfLeaving":"Jan",
        "YearOfLeaving":"2013",
      }
    ],
    "skillsDescription":"My skills: ",
    "skills":[
      {
        "skillname":"HTML5"
      },
      {
        "skillname":"CSS"
      },
      {
        "skillname":"Reactjs"
      }
    ],
    "portfolio":[
      {
        "name":"X-O Game",
        "description":"Coming soon",
        "imgurl":"images/portfolio/retrocam.jpg",
        "url": "https://x-o-game-snowy.vercel.app/"
      },
      {
        "name":"project2",
        "description":"Coming soon",
        "imgurl":"images/portfolio/coffee.jpg"
      },
      {
        "name":"project3",
        "description":"Coming soon",  
        "imgurl":"images/portfolio/farmerboy.jpg"
      },
      {
        "name":"project4",
        "description":"Coming soon",
        "imgurl":"images/portfolio/judah.jpg"
      }
    ],
  
  }
  
  export default resumeData